/**
 * module for handling user object.
 */
import axios from 'axios';
import server from '@/config';
import moment from 'moment';
import * as Mutations from '../mutation-types';
import readCookie from '../functions/readCookie';

const state = {
  user: null,
  token: '',
  popedAlert: false, // controling the alert would only show once after logined.
  fingerprint: undefined,
};

const mutations = {
  /**
   * log out user
   * @param {*} state vuex.state
   */
  [Mutations.LOGOUT](state) {
    state.logout = false;
    state.user = null;
    const date = moment().year(1970);
    document.cookie = `Token=;expires=${date.toDate()};path:/`;
    state.popedAlert = false;
  },
  [Mutations.ALERT_POPED](state) {
    state.popedAlert = true;
  },
};

const actions = {
  /**
   * login and get user token
   * @param {*} param0 vuex attribute
   * @param {*} payload payload with username and password
   */
  login({ commit, state, dispatch }, payload) {
    return axios.post(`${server}/api/token-auth/`, {
      username: payload.username,
      password: payload.password,
      recaptchaToken: payload.recaptchaToken,
    })
    .then((res) => {
      const expiredDate = moment().add(3, 'days');
      document.cookie = `Token=${res.data.token};expires=${expiredDate.toDate()};path:/;`;
      state.token = res.data.token;
      state.errorMsg = '';
      commit('CREATE_INSTANCE');
    });
  },

  /**
   * get user profile with token
   * @param {*} param0 vuex attribute
   */
  getUser({ commit, state, rootState, dispatch }) {
    return axios.get(`${server}/api/user-info/`, {
      headers: {
        Authorization: `Token ${readCookie('Token')}`,
      },
    })
    .then((res) => {
      state.user = res.data;
      state.logined = true;
      const medAppPrivilege = state.user.med_app_privilege;
      if (medAppPrivilege !== null && medAppPrivilege !== undefined) {
        rootState.apps.management.functions.fetchDrug.privilege = medAppPrivilege.fetch;
        rootState.apps.management.functions.returnDrug.privilege = medAppPrivilege.return_drug;
        rootState.apps.management.functions.refillDrug.privilege = medAppPrivilege.refill;
        rootState.apps.management.functions.inventory.privilege = medAppPrivilege.inventory;
        rootState.apps.management.functions.createDrug.privilege = medAppPrivilege.create;
        rootState.apps.management.functions.removeDrug.privilege = medAppPrivilege.remove;
        rootState.apps.management.functions.removeOutdatedDrug.privilege = medAppPrivilege.remove_outdated;
        rootState.apps.management.functions.schedule.privilege = medAppPrivilege.fetch_by_schedule;
        rootState.apps.management.functions.scheduleReturn.privilege = medAppPrivilege.fetch_by_schedule;
        rootState.apps.management.functions.lockBox.privilege = medAppPrivilege.lockBox;
        rootState.apps.management.functions.fetchDrugSchedule.privilege = medAppPrivilege.batch_fetch;
        rootState.apps.management.functions.waste.privilege = medAppPrivilege.waste;
        rootState.apps.management.functions.recycleEmpty.privilege = medAppPrivilege.recycle_empty;
        rootState.apps.management.functions.returnEmpty.privilege = medAppPrivilege.return_empty;
      }
      dispatch('recordAction', { eventType: 'LOGIN' });
      // rootState.instance.post('/api/user-offline/', { user_id: state.user.id }); // dirty hack
    });
  },
  logout({ commit, rootState, dispatch }) {
    // rootState.instance.post('/api/user-offline/', { user_id: state.user.id });
    dispatch('recordAction', { eventType: 'LOGOUT' });
    commit('LOGOUT');
  },
  setOnline({ state, rootState }) {
    return rootState.instance.post('/api/user-online/', {
      user_id: state.user.id,
    });
  },
  setOffline({ state, rootState }) {
    return rootState.instance.post('/api/user-offline/', {
      user_id: state.user.id,
    });
  },
  /**
   * get token with given barcode.
   * @param {*} param0 vuex attribute
   * @param {String} barcode barcode
   */
  loginWithBarcode({ commit, state }, barcode) {
    return axios.post(`${server}/api/barcode-login/`, {
      barcode,
    })
    .then((res) => {
      const expiredDate = moment().add(3, 'days');
      document.cookie = `Token=${res.data.token};expires=${expiredDate.toDate()};path:/;`;
      state.token = res.data.token;
      state.errorMsg = '';
      commit('CREATE_INSTANCE');
    });
  },
  loginWithFingerprint({ commit, state }, feature) {
    return axios.post(`${server}/api/fingerprint-login/`, {
      feature,
    })
    .then((res) => {
      const expiredDate = moment().add(3, 'days'); // token expired in three days
      document.cookie = `Token=${res.data.token};expires=${expiredDate.toDate()};path:/;`;
      state.token = res.data.token;
      state.errorMsg = '';
      commit('CREATE_INSTANCE');
    });
  },
  sendScanFingerCommand({ dispatch, rootState }) {
    dispatch('submitCommand', {
      command: 'capture_finger',
    });
  },
  sendCheckFingerPrinterStatusCommand({ dispatch, rootState }) {
    dispatch('submitCommand', {
      command: 'check_fingerprinter_status',
    });
  },
  sendGetFingerFeatureCommand({ dispatch, rootState }) {
    dispatch('submitCommand', {
      command: 'get_finger_feature',
    });
  },
  sendCancelFingerCaptureCommand({ dispatch, rootState }) {
    dispatch('submitCommand', {
      command: 'cancel_capture',
    });
  },
  /**
   * async password login function
   * @param {*} param0 vuex attribute
   * @param {*} payload payload for 'login' function
   */
  async loginAndGetUser({ dispatch, commit, state }, payload) {
    await dispatch('login', payload);
    await dispatch('getUser');
    // await dispatch('setSystemId');
    // dispatch('setOnline');
    // await dispatch('resetCabinet');
  },
  /**
   * async barcode login function
   * @param {*} param0 vuex attribute
   * @param {*} payload payload for 'barcode login' function
   */
  async barcodeLoginAndGetUser({ dispatch, commit }, payload) {
    await dispatch('loginWithBarcode', payload.barcode);
    await dispatch('getUser');
    // await dispatch('setSystemId');
    // dispatch('setOnline');
    // await dispatch('resetCabinet');
  },
  async fingerpinrtLoginAndGetUser({ dispatch }, payload) {
    await dispatch('loginWithFingerprint', payload.feature);
    await dispatch('getUser');
  },
};


const userModule = {
  state,
  mutations,
  actions,
};

export default userModule;



// WEBPACK FOOTER //
// ./src/vuex/module/user.js